import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/w/:web',
      name: 'Web',
      component: resolve => require(['@/view/site/index'], resolve)
    },
    {
      path: '/w/:web/p/:plan',
      name: 'WebPlan',
      component: resolve => require(['@/view/site/index'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js